<template>
  <div data-component-group="filter-forms" class="tracking-networks-filters">
    <FiltersForm
      :has-filters="hasFilters"
      @filter="onFilter"
      @clear="onClearFilters"
      v-model="selectedCountries"
    >
      <v-text-field
        clearable
        v-model="search"
        type="search"
        label="Network name"
        prepend-inner-icon="search"
        hide-details
      />
    </FiltersForm>
  </div>
</template>

<script>
  import FiltersForm from './FiltersBase';
  import { isNonEmptyStr, isNonEmptyArr, escapeSearch } from '@/utils';
  import filterUrlSync from '@/mixins/filterUrlSync';

  export default {
    mixins: [filterUrlSync],
    components: {
      FiltersForm,
    },
    emits: ['filter', 'clearFilters'],
    data() {
      return {
        urlConfig: [
          { field: 'search', urlKey: 'search', type: 'string' },
          { field: 'selectedCountries', urlKey: 'countries', type: 'string[]' },
        ],
        search: null,
        selectedCountries: [],
      };
    },
    computed: {
      hasFilters() {
        const { search, selectedCountries } = this;
        return isNonEmptyStr(search) || isNonEmptyArr(selectedCountries);
      },
    },
    methods: {
      onFilter() {
        const formattedSearch = escapeSearch(this.search);

        this.syncFiltersToUrl();

        this.$emit('filter', {
          search: formattedSearch,
          countries: this.selectedCountries,
        });
      },
      onClearFilters() {
        this.search = null;
        this.selectedCountries = [];

        this.clearFiltersUrl();

        this.$emit('clearFilters');
      },
    },
  };
</script>
